import PropTypes from "prop-types";
import { useNavigate } from "react-router-dom";
import { useLoader } from "@/hooks/LoaderProvider";
import WebIcon from "@/components/common/Web_Icons";

const TransactionCard = ({ _id, title, user, amount, date, time, status }) => {
  const navigate = useNavigate();
  const { showLoader, hideLoader } = useLoader();

  const handleClick = async (e) => {
    e.stopPropagation();
    showLoader();
    // Simulate API call
    setTimeout(() => {
      hideLoader();
      navigate(`/dashboard/financial/transaction/${_id}`);
    }, 2000);
  };

  return (
    // Added return statement here
    <div
      className="p-2 mb-2 transition-shadow bg-[var(--header-bg)] shadow-sm cursor-pointer hover:shadow-md"
      onClick={handleClick}>
      <div className="flex items-center justify-between">
        <div className="flex items-center gap-4">
          <div className="bg-secondary p-2 rounded-full flex items-center justify-center min-w-[40px] min-h-[40px]">
            <WebIcon icon="Watch" size="large" />
          </div>
          <div className="flex flex-col">
            <h3 className="font-bold text-[15px] text-black truncate w-[100px]">
              {title}
            </h3>
            <p className="dark-mode-text text-small-xs">{user}</p>
          </div>
        </div>
        <div className="flex flex-col items-end text-right">
          <p className="font-semibold text-black text-bold">₦{amount}</p>
          <p className="dark-mode-text text-small-xs">
            {date} - {time}
          </p>
          {status && (
            <span
              className={`text-small-small font-bold flex items-center gap-1.5 ${
                status === "Approved"
                  ? "text-primary"
                  : status === "Pending"
                  ? "text-warning"
                  : "text-danger"
              }`}>
              <span className="w-1.5 h-1.5 rounded-full bg-current inline-block" />
              {status}
            </span>
          )}
        </div>
      </div>
    </div>
  );
};

// Update PropTypes to make status optional
TransactionCard.propTypes = {
  _id: PropTypes.string, // Made optional
  title: PropTypes.string,
  user: PropTypes.string, // Made optional
  amount: PropTypes.string,
  date: PropTypes.string,
  time: PropTypes.string,
  status: PropTypes.oneOf(["Approved", "Pending", "Rejected"]),
};

export default TransactionCard;
